import _ from 'lodash'
import { utils } from 'frontend-js-shared'

const DEFAULT_TIMEZONE = 'America/Mexico_City'

const organization = function (state) {
  return state.organization
}

const organizationSettingsWidgetsLimit = function (state) {
  return state.organization.settingsWidgetsLimit || 5
}

const tags = function (state) {
  return state.tags
}

const defaultTag = function (state) {
  const allTags = state.tags

  return allTags.find(tag => {
    return tag.isDefault
  })
}

const timezone = function (state) {
  return state.organization.timezone || DEFAULT_TIMEZONE
}

const organizationId = function (state) {
  return state.organizationId
}

const siteId = function (state) {
  return state.siteId
}

const account = function (state) {
  return state.account
}

const accountLocation = function (state) {
  const { account } = state

  return {
    organization: _.get(account.organization, '_id'),
    site: _.get(account.site, '_id'),
    tags: _.get(account, 'tags', []) || [],
  }
}

const authorizedSiteIds = function (state, getters, rootState, rootGetters) {
  return utils.getAuthorizedSiteIds({
    account: state.account,
    organizationSiteGroups:
      getters.organizationSiteGroups ??
      rootGetters?.organizationSiteGroups ??
      [],
  })
}

const authorizedSiteDetails = function (state, getters) {
  if (!utils.isSiteAdmin(state.account)) return []

  const authorizedIds = new Set(getters.authorizedSiteIds ?? [])
  const organizationSites = getters.organizationSites ?? []

  return organizationSites.filter(site =>
    authorizedIds.has(utils.getEntityId(site))
  )
}

const token = function (state) {
  return state.token
}

const loggedIn = function (state) {
  return Boolean(state.token)
}

const accountFullName = function (state) {
  return `${state?.account?.displayname ?? ''} ${
    state?.account?.familyname ?? ''
  }`.trim()
}

const reverScore = function (state) {
  return state.reverScore
}

const accountId = function (state) {
  return state.userId
}

const availableFeatures = function (state) {
  const availableFeatures = []
  if (state.organization.featuresEnabled__quickAction)
    availableFeatures.push('quickAction')

  if (state.organization.featuresEnabled__problemSolving)
    availableFeatures.push('problemSolving')

  if (state.organization.featuresEnabled__improvementIdea)
    availableFeatures.push('improvementIdea')

  if (state.organization.featuresEnabled__translation)
    availableFeatures.push('translation')

  return availableFeatures
}

function organizationAISettings(state) {
  return state?.organization?.aiSettings ?? {}
}

const accountOrganizations = function (state) {
  return state.accountOrganizations
}

const pendingOrgSwitch = function (state) {
  return state.pendingOrgSwitch
}

const isSwitchingOrganizations = function (state) {
  return state.isSwitchingOrganizations
}

const switchingToOrganizationName = function (state) {
  return state.switchingToOrganizationName
}

const getters = {
  account,
  accountFullName,
  accountId,
  accountLocation,
  accountOrganizations,
  authorizedSiteIds,
  authorizedSiteDetails,
  availableFeatures,
  defaultTag,
  isSwitchingOrganizations,
  loggedIn,
  organization,
  organizationAISettings,
  organizationId,
  organizationSettingsWidgetsLimit,
  pendingOrgSwitch,
  reverScore,
  siteId,
  switchingToOrganizationName,
  tags,
  timezone,
  token,
}

export default getters
